export const tabConstants = {
    '0': 'Overview',
    '1': 'Billing',
};

export default tabConstants;
